import axios from 'axios';
import envs from '@/envs';
import request from '@/utils/request';

const baseURL = process.env.NODE_ENV === 'development' ? envs.devUrl : envs.buildUrl;

export async function loginByPassword(userId, password) {
  // 로그인의 경우 공통 인스턴스 사용 안 함
  return (
    await axios({
      baseURL,
      url: '/login',
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: { userId, password },
    })
  ).data;
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: {},
  });
}
